<template>
  <v-card class="mx-auto mt-10" max-width="600" min-height="100%">
    <v-card-title>Login</v-card-title>
    <v-card-subtitle class="red--text" v-if="loginError">
      {{ loginError }}</v-card-subtitle
    >
    <v-card-subtitle class="blue--text" v-if="registerSuccess">
      Register Success<br />Please check your e-mail for the confimation
      link</v-card-subtitle
    >
    <v-form ref="form">
      <v-card-text>
        <v-text-field
          v-model="email"
          label="Email"
          :error-messages="emailErrors"
          @input="$v.email.$touch()"
          @blur="$v.email.$touch()"
          required
        ></v-text-field>
        <v-text-field
          v-model="password"
          label="Password"
          type="password"
          :error-messages="passwordErrors"
          @input="$v.password.$touch()"
          @blur="$v.password.$touch()"
          required
        ></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="$router.push('/forgot-password')" text
          >Forgot/Change password</v-btn
        >
        <v-spacer />
        <v-btn color="primary" @click="$router.push('/register')">
          Register
        </v-btn>
        <v-btn :disabled="loading" color="primary" @click="submit">
          Login
          <v-progress-circular
            v-if="loading"
            indeterminate
            :size="25"
          ></v-progress-circular>
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { mapActions, mapGetters } from "vuex";
import store from "@/store";

export default {
  name: "VuelidateLogin",
  validations: {
    email: { required },
    password: { required }
  },
  methods: {
    ...mapActions("cognito", ["signInUser", "signOut"]),
    async submit() {
      this.loginError = null;
      store.commit("auth/setRegisterSuccess", null);
      if (!this.$refs.form.validate()) return;
      if (!this.email || !this.password) {
        this.loginError = "Please fill in the fields";
        return;
      }
      try {
        this.loading = true;
        const gluidId = await store.dispatch("auth/login", {
          email: this.email,
          password: this.password
        });
        this.loading = false;
        this.$router.replace(`/${gluidId}`);
      } catch (err) {
        this.loginError = err.message;
        this.loading = false;
      }
    }
  },
  computed: {
    ...mapGetters({ registerSuccess: "auth/registerSuccess" }),
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.required && errors.push("Email is required");
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.required && errors.push("Password is required");
      return errors;
    }
  },
  data: () => ({
    email: null,
    password: null,
    loginError: null,
    loading: false
  })
};
</script>

<style scoped></style>
